import { Icons } from '@/utils/Icons';
import { sportsIconMap } from '@/utils/constants';

// Sports without an image in `sportsIconMap` get a matching react-icon instead of the trophy.
const FALLBACK_ICONS: Record<string, typeof Icons.Trophy> = {
  Baseball: Icons.Baseball,
  Rugby: Icons.Rugby,
};

/**
 * Sport icon in the shell text colour. The source images are dark artwork, so they are
 * flattened to black with `brightness-0`, then inverted to white in the dark theme.
 */
const SportIcon = ({ name, className = 'size-5' }: { name: string; className?: string }) => {
  const src = sportsIconMap[name];
  if (src) {
    return (
      <img
        src={src}
        alt=""
        className={`${className} shrink-0 object-contain opacity-90 brightness-0 invert light:invert-0`}
      />
    );
  }
  const Fallback = FALLBACK_ICONS[name] ?? Icons.Trophy;
  return <Fallback className={`${className} shrink-0 text-shell-fg opacity-90`} />;
};

export default SportIcon;
